<template>
  <b-container
    tag="section"
    class="settings-cont plan-subscription">
    <b-row>
      <b-col
        sm="12"
        md="10"
        lg="8"
        offset-md="1"
        offset-lg="2"
        class="mb-5">
        <img
          class="sendbee-logo"
          src="~@/assets/img/SB-Images/app-logo.svg"
          alt="AI Number" >
        <h2>
          Activate your subscription
        </h2>
        <span class="description">{{ merchant.plan }}</span>
        <template v-if="userIsOwner">
          <b-form-group class="mt-5">
            <label>
              Credit or Debit Card
            </label>
            <StripeCard
              ref="stripeCard"
              :public-key="stripePublishableKey"
              @handle-error="handleStripeErrors"/>
            <span
              v-if="validationErrors.cardToken"
              class="validation-error">{{ validationErrors.cardToken }}</span>
          </b-form-group>
          <b-form-group>
            <b-col
              md="3"
              class="px-0">
              <b-input
                v-model="coupon"
                maxlength="16"
                placeholder="Coupon"/>
            </b-col>
            <span
              v-if="validationErrors.coupon"
              class="validation-error">{{ validationErrors.coupon }}</span>
          </b-form-group>
          <div
            v-if="showSuccessMessage"
            class="account-settings__success">
            Payment successful.
          </div>
          <div
            v-if="errorMessage"
            class="error-message">
            {{ errorMessage }}
          </div>
          <b-button
            :class="{loading: saving}"
            :disabled="saving"
            class="btn-round btn-save mt-4 mb-4"
            @click="prepareSubmit">
            <span v-if="!saving">Subscribe</span>
            <div class="loader"><div class="loading-circle"/></div>
          </b-button>
        </template>
        <template v-else>
          <h3 class="message mt-5">
            Only business account owner can activate this subscription.
          </h3>
        </template>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import '@/assets/css/modules/_settings.scss';

import setValidationErrors from '@/helpers/validationErrors';
import { roleInMerchant } from '@/helpers/guards/roleInMerchant';
import { mapGetters, mapActions } from 'vuex';
import StripeCard from '../common/StripeCard';

export default {
  name: 'PlanSubscription',
  components: {
    StripeCard,
  },
  data() {
    return {
      coupon: '',
      saving: false,
      showSuccessMessage: false,
      errorMessage: '',
      validationErrors: {},
    };
  },
  computed: {
    ...mapGetters({
      planSubscriptionUpdated: 'merchant/planSubscriptionUpdated',
      subscriptionsListReloaded: 'merchant/subscriptionsListReloaded',
      apiError: 'merchant/apiError',
      merchant: 'merchant/merchant',
      currentOrganisation: 'organisation/currentOrganisation',
      stripePublishableKey: 'system/stripePublishableKey',
    }),
    userIsOwner() {
      return roleInMerchant(this.currentOrganisation.id) === 'owner';
    },
  },
  watch: {
    subscriptionsListReloaded(loaded) {
      if (loaded) {
        this.saving = false;
        this.showSuccessMessage = true;
        setTimeout(() => {
          this.$router.push({
            name: 'Chat',
          });
        }, 1000);
      }
    },
    planSubscriptionUpdated(updated) {
      if (updated) {
        // this.fetchMerchantSubscriptions();
      }
    },
    apiError(error) {
      this.saving = false;
      if (error.status === 422) {
        this.validationErrors = setValidationErrors(error.data.errors);
      } else {
        this.errorMessage = error.data.message;
      }
    },
  },
  mounted() {
    this.fetchMerchant(this.$route.params.merchant_id);
  },
  methods: {
    ...mapActions({
      updatePlan: 'merchant/updatePlan',
      // fetchMerchantSubscriptions: 'merchant/fetchSubscriptions',
      fetchMerchant: 'merchant/fetchMerchant',
    }),
    handleStripeErrors(error) {
      this.validationErrors.cardToken = error;
      this.saving = false;
    },
    prepareSubmit() {
      this.saving = true;
      this.errorMessage = '';
      this.validationErrors = {};

      this.$refs.stripeCard.getStripeToken(this.subscribeToPlan);
    },
    subscribeToPlan() {
      this.updatePlan({
        merchant_id: this.$route.params.merchant_id,
        data: {
          card_token: this.$refs.stripeCard.token,
          coupon: this.coupon,
          plan: 'business',
        },
      });
    },
  },
};
</script>
